import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import UserHeirachyTable from "./UserHeirachyTable";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import SelectDropdown from "../shared/SelectDropdown";
import MultiSelectTags from "../shared/MultiSelectTags";
import { useNavigate, useLocation } from "react-router-dom";

const UserHeirarchy = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [branchData, setBranchData] = useState([]);
  const [branch2Data, setBranch2Data] = useState([]);
  const [seniorUserOptions, setSeniorUserOptions] = useState([]);
  const [authorizedUserOptions, setAuthorizedUserOptions] = useState([]);
  const [branchUserData, setBranchUserData] = useState([]);
  const [branchEmployeeData, setBranchEmployeeData] = useState([]);
  const [formInquiryData, setFormInquiryData] = useState({
    userSelected: "",
    branch_id: "",
    IsSelf: "",
    BranchPermission: "",
    EmployPermission: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const handleUserChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        userSelected: selected.value,
      }));
    }
  };

  const fetchEmployeesByBranch = async (branchIds) => {
    try {
      const formData = new FormData();
      formData.append("branch_ids", branchIds); // Comma-separated branch IDs
      formData.append("created_by", userId);
      formData.append("moduleId", M_id);
      const result = await fetchFormData(
        "get-employees-by-branch",
        formData,
        "POST"
      );

      if (result?.code === 200 && result?.data) {
        setBranchUserData(getValueLabel(result.data, "name", "id") || []);
        setBranchEmployeeData(getValueLabel(result.data) || []);
      } else {
        console.error("No employees found for selected branches");
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };
  const handleBranchChange = async (value) => {
    if (value) {
      setFormInquiryData((prev) => ({
        ...prev,
        branch_id: value.value,
      }));
      const employees = await fetchEmployeesByBranch(value.value);
      setSeniorUserOptions(employees);
    }
  };

  const handleTagChange = async (selectedOptions) => {
    const values =
      selectedOptions?.map((option) => option.value).join(",") || "";
    setFormInquiryData((prev) => ({
      ...prev,
      BranchPermission: values,
    }));

    if (values) {
      const employees = await fetchEmployeesByBranch(values);
      setAuthorizedUserOptions(employees);
    }
  };

  const handlebranchUserChange = (selectedOptions) => {
    const values =
      selectedOptions?.map((option) => option.value).join(",") || "";
    setFormInquiryData((prev) => ({
      ...prev,
      EmployPermission: values,
    }));
  };

  const fetchAllData = async () => {
    const formData = new FormData();
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    const result = await fetchFormData("branch/listdropdown", formData, "POST");

    if (result) {
      const user = result.branches;
      setBranchData(getValueLabel(user, "branch_name", "id") || []);
      setBranch2Data(getValueLabel(user) || []);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const { userSelected, EmployPermission, BranchPermission } =
        formInquiryData;

      const empIds = EmployPermission?.split(",") || [];
      const isSelf = empIds.includes(userSelected.toString()) ? 1 : 0;

      const form = new FormData();
      form.append("IsSelf", isSelf);
      form.append("BranchPermission", BranchPermission);
      form.append("EmployPermission", EmployPermission);

      const response = await fetchFormData(
        `user/updatepermission/${userSelected}`,
        form,
        "POST",
        true
      );

      if (response && response.data) {
        topTost({
          title: response?.message || "No data found",
          icon: "success",
        });
        // navigate(`/employee/employee-list?id=${M_id}`);
      } else {
        topTost({
          title: response?.message || "No data found",
          icon: "info",
        });
      }
    } catch (error) {
      console.error("Filter submit error:", error);
      topTost({
        title: "Unexpected error occurred",
        icon: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetFormInquiryData = () => {
    setFormInquiryData({
      userSelected: "",
      branch_id: "",
      IsSelf: "",
      BranchPermission: "",
      EmployPermission: "",
    });
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader></PageHeader>

          <div className="main-content-top">
            <div className="row">
              <div className="col-lg-12 mt-3">
                <div className="card stretch stretch-full function-table">
                  <div className=" mt-5 px-4 d-flex align-items-center justify-content-between">
                    <h5 className="fw-bold mb-0 me-4">
                      <span className="d-block mb-2">
                        Authorized To:{" "}
                        <span className="fw-lighter px-2 fs-14 ">
                          ( Select the permissions for the authorized data. )
                        </span>
                      </span>
                    </h5>
                  </div>
                  <div className="card-body p-15">
                    <form onSubmit={handleSubmit}>
                      <div className="row px-3 my-3 "></div>
                      <div className="row px-3 my-3 ">
                        <div className="col-md-2 py-3">
                          <label className="fw-semibold">
                            Branch:
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-lg-4">
                          <SelectDropdown
                            options={branchData}
                            icon="feather-home"
                            name="branch_id"
                            value={Number(formInquiryData.branch_id)}
                            selectedOption={
                              branchData.find(
                                (opt) => opt.value === formInquiryData.branch_id
                              ) || null
                            }
                            defaultSelect="Select Branch"
                            onSelectOption={handleBranchChange}
                            required={true}
                          />
                        </div>
                        <div className="col-md-2 py-3">
                          <label className="fw-semibold">
                            Senior User: <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-lg-4">
                          <SelectDropdown
                            options={branchUserData}
                            selectedOption={
                              branchUserData.find(
                                (opt) =>
                                  opt.value === formInquiryData.userSelected
                              ) || null
                            }
                            defaultSelect={"Select Assigned User"}
                            onSelectOption={handleUserChange}
                            value={formInquiryData.userSelected}
                            icon="feather-user"
                            required={true}
                          />
                        </div>
                      </div>
                      <div className=" mt-5 mb-5 px-3 d-flex align-items-center justify-content-between">
                        <h5 className="fw-bold mb-0 me-4">
                          <span className="d-block mb-2">
                            {"Authorized For:"}
                            <small className="fw-lighter px-2 fs-14 ">
                              (Authorized person can view and manage all the
                              permissions of the selected user.)
                            </small>
                          </span>
                        </h5>
                      </div>
                      <div className="row px-3 my-3 ">
                        <div className="col-md-2 py-3">
                          <label className="fw-semibold">Branch:</label>
                        </div>
                        <div className="col-lg-4">
                          <MultiSelectTags
                            options={branchData}
                            defaultSelect={[]}
                            placeholder="Select Branch"
                            onChange={handleTagChange}
                          />
                        </div>
                        <div className="col-md-2 py-3">
                          <label className="fw-semibold">
                            User: <span className="text-danger">*</span>
                          </label>
                        </div>
                        <div className="col-lg-4">
                          <MultiSelectTags
                            options={branchUserData}
                            defaultSelect={[]}
                            placeholder="Select Employee"
                            onChange={handlebranchUserChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="customButton mt-4 gap-xxl-2 my-xxl-4">
                        <button
                          type="submit"
                          className="btn btn-lg btn-primary"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg btn-primary"
                          disabled={isSubmitting}
                          onClick={resetFormInquiryData}
                        >
                          Reset
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="main-content">
            <div className="row">
              <UserHeirachyTable />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default UserHeirarchy;
